import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  singleSliderContainer: {
    alignSelf: 'center',
    padding: theme.spacing(0, 5),
    margin: theme.spacing(1, 0),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(0, 10),
      margin: theme.spacing(0, 0, 3),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(0, 10),
      margin: theme.spacing(0, 0, 8),
    },
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(0, 20),
    },
  },
  gridContainer: {
    backgroundColor: 'rgba(242, 255, 255, 0.50)',
    flexWrap: 'wrap-reverse',
  },
  singleSliderSectionWrapper: {
    backdropFilter: 'blur(60px)',
    padding: theme.spacing(3),

    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(10),
    },
    [theme.breakpoints.up('lg')]: {
      padding: theme.spacing(12, 14),
    },
  },
  singleSliderHeader: {
    textAlign: 'start',
    marginBottom: theme.spacing(4),
  },
  singleSliderDescription: {
    textAlign: 'start',
    marginBottom: theme.spacing(5),
    '& span': {
      display: 'block',
    },
  },
  singleSliderImage: {
    width: '100%',
    height: '100%',
    minHeight: '300px',
    [theme.breakpoints.up('sm')]: {
      minHeight: '650px',
    },
    [theme.breakpoints.up('md')]: {
      minHeight: '450px',
    },
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
  },
}))
